import Mask from 'vanilla-masker'

export const isDefined = (value) => value !== null && value !== undefined

export const isFilled = (value) => value.trim() !== ''

export const removeMask = (value) => value.replace(/[^\d]+/g, '')

/** Remove tudo exceto dígitos e letras (para CNPJ alfanumérico). */
export const removeMaskAlphanumeric = (value) =>
  `${value || ''}`.replace(/[^\dA-Za-z]/g, '')

export const format = (value, regex) => {
  value = `${value}`

  if (!isDefined(value) || !isFilled(value)) {
    return ''
  }

  value = removeMask(value)

  return Mask.toPattern(value, regex)
}

export const getCPFMask = (t = (value) => value) => t('cpf.mask')

export const formatCPF = (value, t = (value) => value) =>
  format(value, getCPFMask(t))

export const getCNPJMask = (t = (value) => value) => t('cnpj.mask')

export const formatCNPJ = (value, t = (value) => value) =>
  format(value, getCNPJMask(t))

export const getPhoneMask = (t = (value) => value) => t('phone.mask')

export const formatPhone = (value, t = (value) => value) =>
  format(value, getPhoneMask(t))

export const getCEPMask = (t = (value) => value) => t('cep.mask')

export const formatCEP = (value, t = (value) => value) =>
  format(value, getCEPMask(t))

export const formatCurrency = (value, t = (value) => value) => {
  if (!isDefined(value)) {
    value = 0
  }

  else if (typeof(value) === 'string') value = value.replace(/\./g, '').replace(',', '.')

  const stringValueToFloat = parseFloat(value)

  return `${t('option.currency')} ${getSign(stringValueToFloat)}${Mask.toMoney(
    (stringValueToFloat || 0).toFixed(t('size.currency')),
    {
      separator: t('separator.currency'),
      delimiter: t('delimiter.currency'),
    }
  )}`
}

export const formatHour = (value) => Mask.toPattern(value, '99:99')

export const formatDecimal = (value, t = (value) => value, numHouses) => {
  if (!value) {
    value = ''
  }
  if (!isDefined(value)) {
    value = 0
  }
  const decimal = numHouses !== undefined ? numHouses : t('size.currency')

  return `${getSign(value)}${Mask.toMoney(
    (value || 0).toFixed(decimal),
    {
      separator: t('separator.currency'),
      delimiter: t('delimiter.currency'),
      precision: decimal
    }
  )}`
}

export const formatDecimalP3 = (value, t = (value) => value) => {
  if (!isDefined(value)) {
    value = 0
  }

  return `${getSign(value)}${Mask.toMoney((value || 0).toFixed(3), {
    separator: t('separator.currency'),
    delimiter: t('delimiter.currency'),
    precision: 3,
  })}`
}

export const formatDecimalDynamic = (
  value,
  numHouses,
  t = (value) => value
) => {
  if (!isDefined(value)) {
    value = 0
  }

  else if (typeof(value) === 'string') value = value.replace(/\./g, '').replace(',', '.')

  if (!isDefined(numHouses)) {
    numHouses = 2
  }

  const stringValueToFloat = parseFloat(value)
  return `${getSign(stringValueToFloat)}${Mask.toMoney((stringValueToFloat || 0).toFixed(numHouses)  , {
    separator: t('separator.currency'),
    delimiter: t('delimiter.currency'),
    precision: numHouses,
  })}`
}

const getSign = (value) => (value < 0 ? '-' : '')

export const formatMoney = (value) => {
  if (!isDefined(value)) {
    value = '00,00'
  }
  return Mask.toMoney(value)
}

export const formatPercentage = (value) => {
  if (!isDefined(value)) {
    value = '0'
  }
  let number = removeMask(value.toString())
  number = number < 10000 ? number : 10000

  let mask
  switch (number.length) {
    case 1:
      mask = '9%'
      break
    case 2:
      mask = '99%'
      break
    case 3:
      mask = `999%`
      break
    case 4:
      mask = `9999%`
      break
    case 5:
      mask = `99999%`
      break
    default:
      mask = `99999%`
      break
  }

  value = Mask.toPattern(number, mask)

  if (!isDefined(value)) {
    value = 0
  }

  return value
}


export const formatPercentageWithoutLimit = (value) => {
  if ( ! isDefined(value)) {
    value = '0'
  }
  const number = removeMask(value.toString())
  const mask = "9".repeat(number.length).concat("%");
  value = Mask.toPattern(number, mask)

  if ( ! isDefined(value)) {
    value = 0
  }

  return value
}


export const formatTpStatus = (value, headerLabel, t) => {
  if (!isDefined(value)) {
    return '-'
  }

  return t(`${headerLabel}.${value}`)
}

/**
 * Formata CNPJ alfanumérico com pontos, barra e hífen: XX.XXX.XXX/XXXX-XX
 * Ex.: 33592DH7000117 → 33.592.DH7/0001-17
 */
export const formatAlphanumericCNPJ = (value) => {
  if (!value) return value
  const raw = removeMaskAlphanumeric(value)
  if (raw.length !== 14) return value
  return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(12, 14)}`
}

export const formatDocument = (value, t = (value) => value) => {
  if (value) {
    if (/[a-zA-Z]/.test(value)) {
      const raw = removeMaskAlphanumeric(value)
      if (raw.length === 14) return formatAlphanumericCNPJ(value)
      return value
    }
    const digitsOnly = removeMask(value)
    return format(
      value,
      digitsOnly.length === 11 ? getCPFMask(t) : getCNPJMask(t)
    )
  }

  return value
}


export const isAlphanumericCNPJ = (value) => {
  if (!value) return false
  return /[a-zA-Z]/.test(value)
}

/**
 * Only numbers
 *
 * @param {number} amount - Amount of digits
 */
export const onlyNumbers = (amount = 8) => '9'.repeat(amount)
